import React, { useEffect, useRef, useState } from "react";
import { ChevronLeftMini, ChevronRightMini } from "../../assets/SvgIcons";
import { Link } from "react-router-dom";

const watchData = [
  {
    brand: "Rolex",
    model: "GMT-Master II",
    price: "$9,448",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/gmt-master-ii--mod4.htm",
  },
  {
    brand: "Rolex",
    model: "Daytona",
    price: "$14,650",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/daytona--mod2.htm",
  },
  {
    brand: "Rolex",
    model: "Submariner",
    price: "$7,462",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/submariner--mod1.htm",
  },
  {
    brand: "Rolex",
    model: "Datejust",
    price: "$1,338",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/datejust--mod45.htm",
  },
  {
    brand: "Rolex",
    model: "Day-Date",
    price: "$8,253",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/day-date--mod47.htm",
  },
  {
    brand: "Rolex",
    model: "Yacht-Master II",
    price: "$16,306",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/yacht-master-ii--mod59.htm",
  },
  {
    brand: "Rolex",
    model: "Oyster Perpetual",
    price: "$1,404",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/oyster-perpetual--mod55.htm",
  },
  {
    brand: "Rolex",
    model: "Sea-Dweller",
    price: "$7,698",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/sea-dweller--mod49.htm",
  },
  {
    brand: "Rolex",
    model: "Day-Date",
    price: "$8,253",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/day-date--mod47.htm",
  },
  {
    brand: "Rolex",
    model: "Yacht-Master II",
    price: "$16,306",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/yacht-master-ii--mod59.htm",
  },
  {
    brand: "Rolex",
    model: "Oyster Perpetual",
    price: "$1,404",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/oyster-perpetual--mod55.htm",
  },
  {
    brand: "Rolex",
    model: "Sea-Dweller",
    price: "$7,698",
    image:
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    link: "/rolex/sea-dweller--mod49.htm",
  },
];

const WellknownCollection = ({ brandName }) => {
  const scrollRef = useRef(null);
  const [cardWidth, setCardWidth] = useState(230);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScrollPosition = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
    }
  };

  useEffect(() => {
    checkScrollPosition(); // initial check on load
    const currentScrollRef = scrollRef.current; // Store current reference

    if (currentScrollRef) {
      currentScrollRef.addEventListener("scroll", checkScrollPosition);
    }

    return () => {
      // Cleanup: check if currentScrollRef is valid
      if (currentScrollRef) {
        currentScrollRef.removeEventListener("scroll", checkScrollPosition);
      }
    };
  }, []);

  useEffect(() => {
    // Function to update cardWidth based on screen size
    const updateCardWidth = () => {
      const screenWidth = window?.innerWidth;
      if (screenWidth < 360) {
        setCardWidth(150);
      } else {
        setCardWidth(230);
      }
    };

    // Initial check
    updateCardWidth();

    // Listen to window resize
    window.addEventListener("resize", updateCardWidth);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", updateCardWidth);
  }, []);

  return (
    <section className="">
      <div className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-2 lg:pt-16 md:pt-14 sm:pt-12 lg:pb-2 md:pb-2 sm:pb-2">
        <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-6 ">
          {brandName || null}
        </h2>

        <div className=" w-full mb-12">
          <div
            ref={scrollRef}
            className="w-full grid lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-3 gap-4 "
          >
            {watchData?.map((watch, index) => {
              return <WatchCard key={index} watch={watch} />;
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
// const WellknownCollection = ({ brandName }) => {
//   const scrollRef = useRef(null);
//   const [cardWidth, setCardWidth] = useState(230);
//   const [canScrollLeft, setCanScrollLeft] = useState(false);
//   const [canScrollRight, setCanScrollRight] = useState(true);

//   const checkScrollPosition = () => {
//     if (scrollRef.current) {
//       const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
//       setCanScrollLeft(scrollLeft > 0);
//       setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
//     }
//   };

//   useEffect(() => {
//     checkScrollPosition(); // initial check on load
//     const currentScrollRef = scrollRef.current; // Store current reference

//     if (currentScrollRef) {
//       currentScrollRef.addEventListener("scroll", checkScrollPosition);
//     }

//     return () => {
//       // Cleanup: check if currentScrollRef is valid
//       if (currentScrollRef) {
//         currentScrollRef.removeEventListener("scroll", checkScrollPosition);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     // Function to update cardWidth based on screen size
//     const updateCardWidth = () => {
//       const screenWidth = window?.innerWidth;
//       if (screenWidth < 360) {
//         setCardWidth(150);
//       } else {
//         setCardWidth(230);
//       }
//     };

//     // Initial check
//     updateCardWidth();

//     // Listen to window resize
//     window.addEventListener("resize", updateCardWidth);

//     // Cleanup event listener on component unmount
//     return () => window.removeEventListener("resize", updateCardWidth);
//   }, []);

//   return (
//     <section className="">
//       <div className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-2 lg:py-16 md:py-14 sm:py-12">
//         <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-6 ">
//           {brandName || null}
//         </h2>

//         <div className="flex items-center w-full mb-12">
//           <button
//             onClick={() => {
//               scrollRef.current.scrollBy({
//                 left: -1 * (cardWidth + 16),
//                 behavior: "smooth",
//               });
//             }}
//             className={
//               canScrollLeft
//                 ? "h-[56px] w-[56px] opacity-5 hover:opacity-100 transition-all ease-in-out flex justify-center items-center bg-[#fff] shadow-lg rounded-lg mr-[-56px] z-10"
//                 : "opacity-5 h-[56px] w-[56px]  transition-all ease-in-out flex justify-center items-center bg-[#fff] shadow-lg rounded-lg mr-[-56px] z-10"
//             }
//           >
//             {ChevronLeftMini}
//           </button>
//           <div
//             ref={scrollRef}
//             className="w-full flex overflow-scroll gap-4 no-scrollbar "
//           >
//             {watchData?.map((watch, index) => {
//               return <WatchCard key={index} watch={watch} />;
//             })}
//           </div>
//           <button
//             onClick={() => {
//               // const maxScrollLeft =
//               //   scrollRef.current.scrollWidth - scrollRef.current.clientWidth;
//               scrollRef.current.scrollBy({
//                 left: cardWidth + 16,
//                 behavior: "smooth",
//               });
//             }}
//             className={
//               canScrollRight
//                 ? "h-[56px] w-[56px] opacity-5 hover:opacity-100 transition-all ease-in-out flex justify-center items-center bg-[#fff] shadow-lg rounded-lg ml-[-56px] z-10"
//                 : "opacity-5 h-[56px] w-[56px]  transition-all ease-in-out flex justify-center items-center bg-[#fff] shadow-lg rounded-lg ml-[-56px] z-10"
//             }
//           >
//             {ChevronRightMini}
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

export default WellknownCollection;

const WatchCard = ({ watch }) => {
  return (
    <Link to={watch?.link} className=" mx-auto   rounded-lg  flex flex-col ">
      <img
        src={watch?.image}
        className="mx-auto lg:min-w-[80px] sm:min-w-[60px] rounded-lg"
        alt=""
      />

      <div className="px-1 pb-2 pt-2 text-oldblue">
        <h3 className="font-semibold text-[14px]">{watch?.model}</h3>
        {watch?.price && <h3 className=" text-[14px]"> {watch?.price}</h3>}
      </div>
    </Link>
  );
};
